import React, { PropsWithChildren } from 'react';
import { Conversation, Group } from 'tim-js-sdk';
import { TUILiveTagParam, useTUILiveContext } from './context/TUILiveContext';

import './styles/index.scss';

import { Icon, IconTypes } from '@tencentcloud/chat-uikit-react';
import { formateNumber } from './untils';
import { useMediaQuery } from 'react-responsive';

export interface TUILiveHeaderBaseProps {
  className?: string;
  conversation?: Conversation;
  contentList?: any;
  group?: Group;
}

interface TUILiveHeaderProps extends TUILiveHeaderBaseProps {
  TUILiveHeader?: React.ComponentType<TUILiveHeaderBaseProps>;
  menuIcon?: React.ReactElement;
  onTagClick?: (data?: TUILiveTagParam) => void;
}

function UnMemoizedTUILiveHeader<T extends TUILiveHeaderProps>(
  props: PropsWithChildren<T>
): React.ReactElement {
  const {
    className,
    conversation,
    group: porpsGroup,
    TUILiveHeader,
    menuIcon: propsMenuIcon,
    onTagClick: propsOnTagClick,
    contentList,
  } = props;

  const {
    group: contextGroup,
    menuIcon: contextMenuIcon,
    onTagClick: contextOnTagClick,
    memberCount,
    groupCounters,
  } = useTUILiveContext('TUILiveHeader');

  const isMobile = useMediaQuery({ maxWidth: '768px' });
  const group = porpsGroup || contextGroup;
  const menuIcon = propsMenuIcon || contextMenuIcon;
  let onTagClick: any;
  if (propsOnTagClick || contextOnTagClick) {
    onTagClick = propsOnTagClick || contextOnTagClick;
  } else {
    onTagClick = () => { };
  }

  if (TUILiveHeader)
    <TUILiveHeader conversation={conversation} group={group} />;

  const groupCustomField = (group?.groupCustomField || []).filter(
    (item) => item?.value
  );

  return (
    <header className={`tui-live-header ${className}`}>
      <div className='tui-live-header-name'>
       {/* {!isMobile &&  <h1>{group?.name || group?.groupID}</h1>} */}
        <div className='tui-live-header-label'>
          <span style={{
            width:'10px',
            height:'10px',
            background:'#fff',
            borderRadius:'100%'
          }}/>
          <p>Live</p>
        </div>
      </div>

      {!isMobile && (
        <div className='tui-live-header-content'>
          <ul className='tui-live-list tag-list'>
            {groupCustomField?.map((item, index) => (
              <li
                role='menuitem'
                tabIndex={index}
                className='tui-live-item tag-item'
                key={item.value}
                onClick={(e) => {
                  onTagClick({ value: item.value, ele: e });
                }}
              >
                {item?.value}
              </li>
            ))}
          </ul>
          
            <ul className='tui-live-list'>
              {contentList?.map((item: any) => (
                <li className='tui-live-item' key={item.icon}>
                  <img className='icon icon-eye' src={item?.icon} alt='eye' />
                  <span className='list-item-text'>
                    {formateNumber(item.value || 0, 1)}
                  </span>
                </li>
              ))}
            </ul>

          {menuIcon}
        </div>
      )}
    </header>
  );
}

export const TUILiveHeader = React.memo(
  UnMemoizedTUILiveHeader
) as typeof UnMemoizedTUILiveHeader;
